export const deleteCookie = (cookieName: string): void => {
  document.cookie = `${cookieName}=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

const defaultTimePlusNow = 365 * 24 * 60 * 60 * 1000 // 1 year

export const setCookie = (cookieName: string, value: string, timePlusNow = defaultTimePlusNow): void => {
  const now = new Date()
  const time = now.getTime()
  const expireTime = time + timePlusNow
  now.setTime(expireTime)
  document.cookie = `${cookieName}=${value}; path=/; expires=${now.toUTCString()};`
}

export const isCookieSet = (cookieName: string): boolean => document.cookie.includes(cookieName)

export const getCookie = (cookieName: string) => {
  const name = `${cookieName}=`
  const decoded = decodeURIComponent(document.cookie)
  const allCookies = decoded.split('; ')

  for (const val of allCookies) {
    if (val.indexOf(name) === 0) {
      return val.substring(name.length)
    }
  }
}
